import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import nl from './locales/nl.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' }
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl }
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((language) => language.code),
    interpolation: {
      // React already escapes interpolated values.
      escapeValue: false
    },
    detection: {
      // Mirror the OIDC provider's resolution order so a language chosen on
      // the login page (?lang= / localStorage) carries into the SPA.
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      // Reuse the same localStorage key the OIDC login page persists, so the
      // two surfaces stay in sync without any extra wiring.
      lookupLocalStorage: 'oidc_lang',
      caches: ['localStorage']
    }
  });

export default i18n;
